<template>
  <div id="vue-tinymce">
    <vue-tinymce v-if="showEditor" v-model="editorVlaue" :setting="setting" />
  </div>
</template>

<script>
import { API_ROOT } from "@config";
export default {
  name: "vueTinymceEditor",
  data() {
    return {
      editorVlaue: this.value,
      setting: {
        menubar: true, // 菜单栏
        //inline: true,   //开启内联模式
        // readonly: false, // 只读
        buttonbar: 'layoutButton',
        // 配置工具 link连接 image图片 media视频 table表单 lists标签 fullscreen全屏
        plugins: this.allFunctions
          ? "link image media table lists fullscreen quickbars wordcount paste emoticons code"
          : "link image media table lists quickbars wordcount paste emoticons code",

        //工具栏
        toolbar1: this.allFunctions
          ? "code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | fullscreen   indent2em lineheight formatpainter axupimgs | styleselect  fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | table image media charmap  | emoticons hr pagebreak insertdatetime print preview layoutButton"
          : "undo redo| fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | image media  | wordcount code  layoutButton ",

        toolbar_drawer: "sliding",
        //
        quickbars_selection_toolbar:
          "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",

        language: "zh_CN",
        height: this.height,
        // 图片上传地址(自动上传)
        // images_upload_url: baseUploadUrl + 'image/vueTinymce/',
        // 允许粘贴图片上传,及格式
        paste_data_images: true,
        images_file_types: "jpeg,jpg,png,gif,bmp,webp",
        // 此处为图片上传处理函数 (手动上传)
        images_upload_handler: (blobInfo, success, failure, progress) => {
          // 方法1：用base64的图片形式上传图片
          // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          // success(img)

          // 方法2：上传oos
          const xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          // xhr.open("POST", baseUploadUrl + "image/vueTinymce/");
          xhr.open("POST", API_ROOT + "/tool/uploadimg");
          // xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded;charset=utf-8')
          // xhr.setRequestHeader('x-token', this.$store.getters.token)
          xhr.upload.onprogress = function (e) {
            progress((e.loaded / e.total) * 100);
          };
          // 成功结果
          xhr.onload = function () {
            if (xhr.status != 200) {
              failure("HTTP Error: " + xhr.status, { remove: true });
              return;
            }
            const json = JSON.parse(xhr.responseText);
            if (json.status != 200) {
              failure("图像上传失败:" + json.msg);
              return;
            }
            success(json.data.file);
          };
          // 失败结果
          xhr.onerror = function () {
            failure("图像上传失败:" + xhr.status);
          };
          // 请求数据
          const formData = new FormData();
          formData.append("file", blobInfo.blob(), blobInfo.filename());
          xhr.send(formData);
        },
        file_picker_callback: (callback, value, meta) => {
          // failure("123123")
          // return false
          let _this = this;
          //文件分类
          var filetype =
            ".pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp3, .mp4";
          //后端接收上传文件的地址
          var upurl = API_ROOT + "/tool/uploadfile";
          //为不同插件指定文件类型及后端地址
          switch (meta.filetype) {
            case "image":
              filetype = ".jpg, .jpeg, .png, .gif";
              upurl = API_ROOT + "/tool/uploadimg";
              break;
            case "media":
              filetype = ".mp3, .mp4";
              upurl = API_ROOT + "/tool/uploadmedia";
              break;
            case "file":
            default:
          }
          //模拟出一个input用于添加本地文件
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", filetype);
          input.click();
          input.onchange = function () {
            var file = this.files[0];
            var xhr, formData;
            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            xhr.open("POST", upurl);
            xhr.onload = function () {
              if (xhr.status != 200) {
                alert("文件上传失败：" + xhr.status)
                // failure("文件上传失败：" + xhr.status);
                return;
              }
              const json = JSON.parse(xhr.responseText);
              if (json.status != 200) {
                alert("文件上传失败：" + json.msg)
                // failure("Invalid JSON: " + xhr.responseText);
                return;
              }
              //请求成功
              if (json.status == 200) {
                // 组装扔回去
                callback(json.data.file, { title: file.name });
              }
            };
            formData = new FormData();
            formData.append("file", file, file.name);
            xhr.send(formData);
          };
        },
        setup: function (edt) {
          edt.ui.registry.addButton('layoutButton', {
            text: '一键排版',
            onAction: function (_) {
              var txt = edt.getContent();

              //清除所有html空格
              txt = txt.replace(/&nbsp;/ig, "");

              //清除所有空行（摘录网上，实测可用）
              var arrPattern = [
                '<p(>|\\s+[^>]*>)(&nbsp|&nbsp;|\\s|　|<br\\s*(\/)?>)*<\/p(>|\\s+[^>]*>)',
                '(<br\\s*(\/)?>((\\s|&nbsp;|&nbsp|　)*)){2,}',
                '(<p(>|\\s+[^>]*>))((&nbsp|&nbsp;|\\s)*<br\\s*(\/)?>)*((.|\n|\r)*?<\/p(>|\\s+[^>]*>))'
              ];
              var arrReplace = ['', '<br />$3', '$1$6'];
              for (var i = 0; i < arrPattern.length; i++) {
                var arrRegExp = new RegExp(arrPattern[i], 'img');
                txt = txt.replace(arrRegExp, arrReplace[i]);
              }

              //清除所有非空格的空白字符，空格字符去除可能导致元素属性出错
              txt = txt.replace(/[\f\n\r\t\v]/ig, "");

              //清除所有span
              txt = txt.replace(/<(\/span|span).*?>/ig, "");

              //清除超链接，将网址分离在后
              txt = txt.replace(/<a.*?href\s*=\s*[\"|\'](.*?)[\"|\'].*?>(.*?)<\/a>/ig, "$2[网址：$1]");
              //实际运行中发现有些错误的a链接可能根本没有href，所以需要再次清理
              txt = txt.replace(/<(\/a|a).*?>/ig, "");

              //清除所有class，为防止有些class不加引号，因此强制规定只清除元素内的class，这种写法最笨和直观，聪明的看下一个
              txt = txt.replace(/<([a-zA-Z1-6]+)(.*?)\s*class\s*=\s*[\"|\']?.*?[\"|\']\s*(.*?)>?/ig, "<$1 $2 $3>");

              //清除所有style属性
              //直接量语法：
              txt = txt.replace(/style\s*?=\s*?([\'\"])[\s\S]*?\1/ig, "");
              //RegExp对象语法，可用于自定义变量，比如出了style以外的class，lang等等
              var v = "style";
              txt = txt.replace(new RegExp(v + "\\s*?=\\s*?([\'\"])[\\s\\S]*?\\1", "ig"), "");

              // //清除所有元素属性，超链接可能被清除
              // txt = txt.replace(/<([a-zA-Z1-6]+)(\s*[^>]*)?>/ig, "<$1>");

              //如果保留img,p,table标签，则为：
              txt = txt.replace(/<(?!table|tr|td|\/table|\/tr|\/td|img|p|\/p).*?>/g, "");
              //给每段落加上样式
              txt = txt.replace(/<p.*?>/ig, "<p style=\"text-indent:2em;\">");
              //给图片加上居中样式
              txt = txt.replace(/<img/ig, "<img style=\"margin: 0px auto; display: block;\" ");
              //给表格加上居中样式
              txt = txt.replace(/<table/ig, "<table style=\"border-collapse: collapse; margin-left: auto; margin-right: auto;\"   border=\"1\" ");

              edt.setContent(txt);
            }
          });
        },
      },
    };
  },
  props: {
    // 接收值父组件传递值
    value: {
      type: String,
      default: ''
    },
    // 高度 默认300
    height: {
      type: Number,
      default: () => {
        return 300;
      },
    },
    // 是否开启全功能
    allFunctions: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    //是否显示编辑器 清空编辑器里面的内容使用
    showEditor: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
  },
  watch: {
    value(newValue) {
      this.editorVlaue = newValue
    },
    editorVlaue: function (newValue, oldNum) {
      // 修改调用者传入的值
      this.$emit('input', newValue)
    },
  },
};
</script>

<style>
/* 富文本按钮功能优先级,最好 > 2500  弹出默认2000+ */
.tox-tinymce-aux {
  z-index: 9999 !important;
}
</style>
